import type { ObjectTag } from '~/features/common/types/objectTag';
import { useQuery } from '@tanstack/react-query';
import { pick } from 'underscore';
import FetchPromise from '~/agent/fetch-promise';
import { TAG_LIMIT, ADMIN_SEARCH_BASE_URL } from '../constants';

export interface GetAdminObjectTagsProps {
  searchTerm?: string;
  sortBy?: 'popularity' | null;
  limit?: number;
}

const getAdminObjectTags = ({
  searchTerm,
  sortBy,
  limit = TAG_LIMIT,
}: GetAdminObjectTagsProps): Promise<ObjectTag[]> => {
  const queryParams = {
    query: searchTerm,
    sort_by: sortBy,
    limit: limit ? limit.toString() : null,
  };
  const queryParamsString = new URLSearchParams(pick(queryParams, Boolean)).toString();
  return FetchPromise.get(`${ADMIN_SEARCH_BASE_URL}/tags?${queryParamsString}`);
};

const GET_ADMIN_OBJECT_TAGS_KEY = ({ searchTerm, sortBy, limit }: GetAdminObjectTagsProps) => [
  'get-admin-content-tags',
  searchTerm,
  sortBy,
  limit,
];

export const useGetAdminObjectTags = (objectTagParams: GetAdminObjectTagsProps) =>
  useQuery<ObjectTag[], JQuery.jqXHR>(GET_ADMIN_OBJECT_TAGS_KEY(objectTagParams), () =>
    getAdminObjectTags(objectTagParams),
  );
